import React from 'react';
import { useParams } from 'react-router-dom';
import '../components/Header.css'; // 复用 Header 的样式

/**
 * Universal Link 中转页面
 * 当用户在浏览器中访问 /wave/:id 或 /profile/:id 时显示
 */
export const UniversalLinkPage = () => {
    const { id } = useParams();
    const appStoreUrl = 'https://apps.apple.com/us/app/marlo-connect-meet-nearby/id6450737280?l=zh-Hans-CN';

    return (
        <div className="download-modal-overlay" style={{ position: 'fixed', zIndex: 9999 }}>
            <div className="download-modal-content">
                <div className="download-modal-body">
                    <img 
                        src={require('../images/download/qr.png')} 
                        alt="QR Code" 
                        className="qr-code"
                    />
                    <div className="download-or-text">OR</div>
                    <img 
                        src={require('../images/download/store.png')} 
                        alt="App Store" 
                        className="store-badge"
                        onClick={() => window.open(appStoreUrl, '_blank')}
                        style={{ cursor: 'pointer' }}
                    />
                                        <p className="download-description">
                        You're almost in.<br/>Download Marlo to continue.
                    </p>
                    <p className="download-subnote" style={{ marginTop: 4, fontSize: 12, color: "#9e9e9e", textAlign: "center" }}>Android coming soon — iOS only for now.</p>
                </div>
            </div>
        </div>
    );
};

export default UniversalLinkPage;
